"use client";

import React from "react";
import dynamic from "next/dynamic";
const Innovations = dynamic(() => import("./innovations"));
const AllStories = dynamic(() => import("./all-stories"));
const UseCaseBanner = dynamic(() => import("./use-case-banner"));
// interface Block {__component: string;[key: string]: any;}
interface UseCaseProps {
  blocks: any[];
  slug: string;
}

interface PageData {
  slug: string;
  query: string;
  label: string;
}

const UseCase: React.FC<UseCaseProps> = ({ blocks, slug }) => {
  const getQuery = (): PageData | undefined => {
    if (slug === "use-cases") {
      return {
        slug,
        query: "use-cases?",
        label: "Use Cases",
      };
    }
    return undefined;
  };

  const pageData = getQuery();

  return (
    <>
      {blocks.length > 0 && (
        <div className="middle-sction blog-page-section">
          {blocks.map((block: any, i) => (
            <div key={i} id={block.__component}>
              {block.__component === "blocks.banner" && (
                <UseCaseBanner block={block} />
              )}
              {block.__component === "blocks.use-cases" && (
                <AllStories block={block} pageData={pageData} />
              )}
              {block.__component === "blocks.cta" && (
                <Innovations block={block} />
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default UseCase;
